import { Duration } from '@js-joda/core';

import {
   ConfidentialAccessLevel,
   ConfidentialityConfiguration,
   ConfidentialityConfigurationQuery,
   ConfidentialityConfigurationSetCommand,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../translations';
import { CONFIDENTIALITY_ACCESS_LEVELS } from '../ConfidentialitySettings.types';

import { ConfidentialityEditModalBean } from './ConfidentialityEditModal.types';

const t = generalSettingsTranslationKeys.confidentialitySettings.modal.actions.save;

type ConfidentialityUpdateActionChildrenRenderProps = {
   updateAccessDurations: (parameters: ConfidentialityEditModalBean) => Promise<void>;
};

type ConfidentialityUpdateActionProps = {
   confidentialityConfiguration: ConfidentialityConfiguration;
   onSuccess: VoidFunction;
   children: (renderProps: ConfidentialityUpdateActionChildrenRenderProps) => JSX.Element;
};

const resolveDuration = (bean: ConfidentialityEditModalBean, accessLevel: ConfidentialAccessLevel): Duration => {
   const index = CONFIDENTIALITY_ACCESS_LEVELS.indexOf(accessLevel);

   return Duration.ofHours(bean.rows[index].accessDurationHours!);
};

export const ConfidentialityUpdateAction = (props: ConfidentialityUpdateActionProps): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, ConfidentialityEditModalBean>(
      (parameters) => {
         const command = new ConfidentialityConfigurationSetCommand();
         command.prescriptionIssuingAccessAllowed = props.confidentialityConfiguration.prescriptionIssuingAccessAllowed;
         command.monitoredAccessDuration = resolveDuration(parameters, 'MONITORED');
         command.authorizedAccessDuration = resolveDuration(parameters, 'AUTHORIZED');
         return command;
      },
      {
         onSuccess: async () => {
            await refetchCqrsQuery(ConfidentialityConfigurationQuery);
            dispatchSnackbarPositiveEvent(t.successMessage);
            props.onSuccess();
         },
      }
   );

   return props.children({
      updateAccessDurations: executeAsync,
   });
};
